import { map, size } from '../../../../../../../lib/utilities';
import Translation from '../../../../translation/translation';

function OpeningHour(props) {
    return (
        <p className="fsf-station__opened-time" key={props.day}>
            <span className="fsf-station__opened-days">{props.day}</span>
            <span className="fsf-station__opened-hours">{props.hours}</span>
        </p>
    );
}

function OpeningHours(props) {
    if (!size(props.openingHours)) {
        return null;
    }
    const { openingHours } = props;

    return (
        <div className="fsf-station__detail">
            <h3 className="fsf-station__detail-headline">
                <Translation translationKey="fitting-station-finder-app-opening-hours" />
            </h3>
            <div className="fsf-station__detail-contents">
                <div className="fsf-station__opened-times">
                    {Object.keys(openingHours).map((hours, index) => {
                        return <OpeningHour day={hours} hours={openingHours[hours]} key={index} />;
                    })}
                </div>
            </div>
        </div>
    );
}

export default OpeningHours;
